import { defineStore } from 'pinia';

import PohlconAuthService from '../services/core/PohlconAuthService';

type AuthState = {
  isAuthenticated: boolean;
  authService: PohlconAuthService;
  userData: any;
};

/** */
export const useAuthStore = defineStore('auth', {
  state: () => {
    const state: AuthState = {
      isAuthenticated: false,
      userData: {},
      authService: new PohlconAuthService(),
    };
    return state;
  },
  actions: {
    /**
     * Boots the authentication store by fetching the account data and setting the necessary properties.
     * If the account data is successfully fetched, the store's `userData` property will be updated and `isAuthenticated` will be set to `true`.
     * If an error occurs while fetching the account data, `isAuthenticated` will be set to `false` and the error will be logged to the console.
     */
    async boot() {
      try {
        const accountData = await this.authService.getAccount();
        this.userData = accountData;
        this.isAuthenticated = true;
      } catch (error) {
        this.isAuthenticated = false;
        console.log(error);
      }
    },
    /**
     * Handles the callback from the authorization server.
     * @returns The return URL or null if no return URL was set.
     */
    async handleCallback(): Promise<string | null> {

      const url = new URL(window.location.href);
      const authorizationCode = url.searchParams.get('code');
      const state = url.searchParams.get('state');

      if (authorizationCode && state) {
        const authenticationSuccess = await this.authService.loginByAuthorizationCode(authorizationCode, state);
      }
      await this.boot(); // reload the user data

      return this.authService.getReturnUrl() || null;
    },
   
    /**
     * Initiates the login process by redirecting the user to the authorization URL.
     */
    async login() {
      const getAuthorizationUrl = await this.authService.getAuthorizationUrl();
      window.location.href = getAuthorizationUrl;
    },

    /**
     * Logs out the user by calling the `logout` method of the `authService`.
     * Sets `isAuthenticated` to `false` and clears the `userData`.
     */
    async logout() {
      await this.authService.logout();

      this.isAuthenticated = false;
      this.userData = {};
    }
  }
});
